<template>
  <figure class="highcharts-figure">
    <highcharts ref="chart" :options="options" />
    <p class="highcharts-description highcharts-linked-description">
      <strong>Figure : </strong>
      {{ $t('compGraphicsPlanesAndTrainsEmissionFactors.help') }}
    </p>
  </figure>
</template>

<script>
import '@/plugins/highcharts.js'
import TRANSPORTS_FACTORS from '@/../data/factors/carbon/transportsFactors.json'
import { EmissionFactor } from '@/models/carbon/Factor.js'

export default {
  name: 'PlanesAndTrainsEmissionFactors',
  props: {
    ghgi: {
      type: Object,
      default: null
    }
  },
  computed: {
    series: function () {
      let series = [
        {
          name: this.$t('combustion'),
          data: []
        },
        {
          name: this.$t('upstream'),
          data: []
        },
        {
          name: this.$t('manufacturing'),
          data: []
        },
        {
          name: this.$t('fugitive'),
          data: []
        }
      ]
      // add plane.shorthaul
      let ef = EmissionFactor.createFromObj(
        TRANSPORTS_FACTORS.plane['shorthaul.contrails']
      )
      series[0].data.push(ef.getFactor().combustion.total)
      series[1].data.push(ef.getFactor().upstream.total)
      series[2].data.push(ef.getFactor().manufacturing.total)
      series[3].data.push(ef.getFactor().fugitive.total)
      // add plane.mediumhaul
      ef = EmissionFactor.createFromObj(
        TRANSPORTS_FACTORS.plane['mediumhaul.contrails']
      )
      series[0].data.push(ef.getFactor().combustion.total)
      series[1].data.push(ef.getFactor().upstream.total)
      series[2].data.push(ef.getFactor().manufacturing.total)
      series[3].data.push(ef.getFactor().fugitive.total)
      // add plane.longhaul
      ef = EmissionFactor.createFromObj(
        TRANSPORTS_FACTORS.plane['longhaul.contrails']
      )
      series[0].data.push(ef.getFactor().combustion.total)
      series[1].data.push(ef.getFactor().upstream.total)
      series[2].data.push(ef.getFactor().manufacturing.total)
      series[3].data.push(ef.getFactor().fugitive.total)
      // add train
      ef = EmissionFactor.createFromObj(
        TRANSPORTS_FACTORS.railway['train.longdistance']
      )
      series[0].data.push(ef.getFactor().combustion.total)
      series[1].data.push(ef.getFactor().upstream.total)
      series[2].data.push(ef.getFactor().manufacturing.total)
      series[3].data.push(0)
      return series
    },
    categories: function () {
      return [
        this.$t('compGraphicsPlanesAndTrainsEmissionFactors.plane.shorthaul'),
        this.$t('compGraphicsPlanesAndTrainsEmissionFactors.plane.mediumhaul'),
        this.$t('compGraphicsPlanesAndTrainsEmissionFactors.plane.longhaul'),
        this.$t('train')
      ]
    },
    options: function () {
      let self = this
      return {
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: this.categories
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t(
              'compGraphicsPlanesAndTrainsEmissionFactors.kg.co2e.km'
            )
          }
        },
        tooltip: {
          formatter: function () {
            let tooltip = this.points[0].x + ' <br />'
            for (let i in this.points) {
              tooltip +=
                '<span style="color:' +
                this.points[i].series.color +
                ';">\u25CF ' +
                '</span> '
              tooltip +=
                this.points[i].series.name +
                ': <b>' +
                Math.round(this.points[i].y * 10000) / 10000
              tooltip +=
                '</b> ' +
                self.$t(
                  'compGraphicsPlanesAndTrainsEmissionFactors.kg.co2e.km'
                ) +
                ' <br />'
            }
            return tooltip
          },
          shared: true
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: this.series
      }
    }
  }
}
</script>

<style scoped>
.highcharts-figure {
  min-width: 320px;
  max-width: 700px;
  margin: 1em auto;
}
.highcharts-description {
  text-align: center;
  color: '#777777';
  font-style: italic;
}
</style>
